//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import navbar from '@/components/ui/navbar'
import loadmore from '@/components/ui/loadmore'
import cardbox from '@/components/ui/cardbox'

import shopCart from '@/components/cusShopCart'
import mainMenuTab from '@/components/mainMenuTab'

export default {
    components: {
        shopCart, mainMenuTab, navbar, loadmore, cardbox,
    },
    data(){
        return {
            cartList:[],
            settlement:{
                price: 0,
                quantity: 0,
                deposit: 0,
                spec_id: [],
            },
            selectAllState: false,
            handleNum: null,
        }
    },
    methods:{

        // 删除购物车
        deleteCart(){

            const selectChecked = [];
            this.cartList.forEach(store=>{
                store.items.forEach(goods=>{
                    if(goods.checked){
                        selectChecked.push(goods.spec_id);
                    }

                })
            })

            if(selectChecked.length === 0){
                this.$vux.toast.text('请先选择需要删除的产品.');
                return;
            }

            const _this = this;
            const opts = {
                url: api.cartDel,
                data: {
                    spec_id: selectChecked.join(","),
                },
                type: 'delete'
            }

            this.$vux.confirm.show({
                title: '删除购物车',
                content: "确认操作会删除已选的商品！",
                onConfirm () {
                    common.query(opts).then(res=>{
                        _this.cartList = res.data;
                    },res=>{
                        _this.$vux.toast.text(res.message);
                    })
                }
            })


        },

        // 提交到订单
        submitCart(){

            for(let i=0;i<this.cartList.length; i++){

                const store = this.cartList[i];
                let quantity = 0,price = 0;

                store.items.forEach(goods=>{
                    if(goods.checked){
                        quantity += parseInt(goods.quantity);
                        price += parseFloat(goods.total);
                    }
                })

                // if(quantity > 0){ // 大于0表示当前店铺有需要结算的商品
                //     if(store.store.min_cond_unit === '件' && store.store.min_cond_num > quantity){
                //         this.$vux.toast.text(store.store.store_name + "，起购件数不足.",'top');
                //         return false;
                //     }
                //     if(store.store.min_cond_unit === '元' && store.store.min_cond_num > price){
                //         this.$vux.toast.text(store.store.store_name + "，起购金额不足.",'top');
                //         return false;
                //     }
                // }
            }


            if(this.settlement.spec_id.length<1){
                return false;
            }

            this.$router.push( "/orderConfirm?spec_id="+this.settlement.spec_id.join(",") );

        },

        // 选择单个商品
        selectGoods: function(goods){
            goods.checked = !goods.checked;
            this.stateOperation();
        },

        // 选择店铺商品
        selectStore: function(stores){
            stores.checked = !stores.checked;
            this.stateOperation('store',stores.checked,stores);
        },

        // 全选所有商品
        selectAll(){
            this.selectAllState = !this.selectAllState;
            this.stateOperation('all',this.selectAllState);
        },

        // 总额，总数，选择状态操作
        stateOperation(type,state,data){

            let price = 0;
            let quantity = 0;
            let deposit = 0;
            let spec_id = [];

            this.cartList.forEach(store=>{
                store.items.forEach(goods=>{
                    // 全选时，[状态为false取消全部选择，如果为true选择全部]
                    if(type==="all"){
                        store.checked = state;
                        goods.checked = state;
                    }
                    // 选择店铺时，
                    if(type==='store' && store.store.store_id === data.store.store_id){
                        goods.checked = state;
                    }

                    if(goods.checked){
                        quantity += parseInt(goods.quantity);
                        price += parseInt(goods.total);
                        deposit += parseInt(goods.deposit);
                        spec_id.push(goods.spec_id);
                    }else{
                         this.selectAllState = false;
                         store.checked = false;
                    }
                })
            })

            this.settlement = {
                price,
                quantity,
                deposit,
                spec_id,
            }

        },

        // 增加减少商品数量 ==> 增减价格后，需要重新计算价格
        changeGoodsQuantity(num,item){

            item.min = item.min || 1; // 最小购买数量，不能小于1.
            item.max = item.max > 0 ? item.max : 100000;

            if(num < 0 && item.quantity <= item.min){
                return false;
            }

            if(num > 0 && item.quantity >= item.stock){
                this.$vux.toast.text("已超出库存总数");
                return false;
            }

            if(num > 0 && item.quantity >= item.max){
                this.$vux.toast.text("商品超出购买数量限制");
                return false;
            }

            const opts = {
                url: api.cartUpdate,
                data: {
                    spec_id: item.spec_id,
                    quantity: num,
                    storeId: common.getCurStoreId(),
                },
                type: 'put',
            }

            common.query(opts).then(res=>{
                const data = res.data;
                item.total = data.total;
                item.stock = data.stock;
                item.deposit = data.deposit;
                item.quantity = data.quantity;
                item.max = data.max;
                item.formula = data.formula;
                item.price = data.price;
                this.stateOperation();
            },res=>{
                this.$vux.toast.text(res.message);
            })
        },

        // 修改商品数量
        modifyGoodsQuantity(e,item){

            let newQuantity = parseInt(e.target.value || 0);
            let oldQuantity = parseInt(item.quantity);
            let num = newQuantity-oldQuantity;

            item.min = item.min || 1; // 最小购买数量，不能小于1.
            item.max = item.max > 0 ? item.max : 100000;

            if(newQuantity < item.min){
                return false;
            }

            if(newQuantity > item.stock){
                e.target.value = oldQuantity;
                this.$vux.toast.text("已超出库存总数");
                return false;
            }

            if(newQuantity > item.max){
                e.target.value = oldQuantity;
                this.$vux.toast.text("商品超出购买数量限制");
                return false;
            }

            clearTimeout(this.handleNum);
            this.handleNum = setTimeout(() => {

                this.changeGoodsQuantity(num,item);
            }, 1000);
        },

        //获取购物车列表
        getCartList(){

            const opts = {
                url: api.cartList,
                data: { storeId: common.getCurStoreId() },
                type:'get'
            };

            common.query(opts).then(res => {
                this.cartList = res.data
            },res => {
                this.$vux.toast.text(res.message);
            });
        },

    },
    mounted(){
        this.getCartList()
    },
}



// WEBPACK FOOTER //
// ./src/views/member/cart.vue